import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import SecuredFileChange from '../../components/SecuredFileChange';
import { endPoints } from '../../Config';
import { handlePostRequest } from '../../service/PostTemplate';
import { handleGetRequest } from '../../service/GetTemplate';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

const CreateTicket = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [ticketTypes, setTicketTypes] = useState([]);

    const ticketImageRef = useRef(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        Title: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Title must contain only alphanumeric values'),
        Message: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Title must contain only alphanumeric values'),
        Files: Yup.string().required('This field is required'),
        TransactionId: Yup.mixed().required('This field is required'),
        TicketTypeId: Yup.mixed().required('This field is required')
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            TransactionId: '',
            TicketTypeId: '',
            Title: '',
            Message: '',
            Files: ''
        },
        onSubmit: async (data) => {
            const formData = new FormData();

            setLoadingBtn(true);

            formData.append('Message', data?.Message || '');
            formData.append('TicketTypeId', data?.TicketTypeId || '');
            formData.append('Title', data?.Title || '');
            formData.append('TransactionId', data?.TransactionId || '');
            formData.append('Message', data?.Message || '');

            if (selectedFile) formData.append('Files', selectedFile);

            const response = await dispatch(handlePostRequest(formData, endPoints.createTicket, true));
            if (response?.status === 200) {
                formik.resetForm();
                navigate('/tickets');
            }
            setLoadingBtn(false);
        }
    });
    const handleTicketIcon = () => {
        ticketImageRef.current.click();
    };

    function handleTicketImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue('Files', '');
        const selectedFile = event.target.files[0];
        const fileTypes = ['image'];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
        } else if (newFile) {
            formik.setFieldValue('Files', newFile?.name);
            setSelectedFile(newFile);
        }
    }
    const getTicketTypes = async () => {
        const response = await handleGetRequest(endPoints.getDropdownTicketsTypes, true, false, dispatch);
        if (response) {
            setTicketTypes(response?.data);
        }
    };

    useEffect(() => {
        getTicketTypes();
    }, []);
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];
    return (
        <div className="p-4">
            {' '}
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Create Ticket</h3>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid grid mb-5">
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="TicketTypeId">Type</label>
                                <Dropdown
                                    id="TicketTypeId"
                                    name="TicketTypeId"
                                    value={formik?.values?.TicketTypeId}
                                    options={ticketTypes}
                                    optionLabel="name"
                                    optionValue="id"
                                    onChange={formik.handleChange}
                                    placeholder="Select Type"
                                    className="w-full"
                                />
                                {formik.touched.TicketTypeId && formik.errors.TicketTypeId && <small className="p-error">{formik.errors.TicketTypeId}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="TransactionId">Transaction ID</label>
                                <InputText id="TransactionId" name="TransactionId" placeholder="Enter Transaction ID" value={formik?.values?.TransactionId} maxLength={30} onChange={formik.handleChange} />

                                {formik.touched.TransactionId && formik.errors.TransactionId && <small className="p-error">{formik.errors.TransactionId}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="Title">Title</label>
                                <InputText id="Title" name="Title" placeholder="Enter Title" value={formik?.values?.Title} maxLength={30} onChange={formik.handleChange} />

                                {formik.touched.TransactionId && formik.errors.Title && <small className="p-error">{formik.errors.Title}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12">
                            <div className="p-field">
                                <label htmlFor="Message">Add Message (max. 1024 characters)</label>
                                <InputTextarea id="Message" name="Message" placeholder="Add Message..." value={formik?.values?.Message} maxLength={30} onChange={formik.handleChange} />
                                {formik.touched.Message && formik.errors.Message && <small className="p-error">{formik.errors.Message}</small>}
                            </div>
                        </div>{' '}
                        <div className="col-12 md:col-6">
                            <div className="mb-3">
                                <div className="field">
                                    <label htmlFor="image">
                                        Upload Image <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <div className="file-input-container file-input-wrapper w-100" onClick={handleTicketIcon}>
                                        <input type="file" accept="image/*" style={{ display: 'none' }} ref={ticketImageRef} onChange={handleTicketImageChange} className="file-input-field" />
                                        <input type="text" placeholder="Choose a file..." value={formik?.values?.Files} readOnly className="file-input-field" />
                                    </div>
                                    {formik.errors.Files ? <small className="p-error">{formik.errors.Files}</small> : ''}
                                </div>
                            </div>
                        </div>
                        <div className="live__SearchBtn p-field col-12 md:col-12 gap-2">
                            <Button label="Save" icon="pi pi-save" type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                            <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => navigate('/tickets')} />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateTicket;
